import React from "react";
import SelectionItem from "../../SelectionItem";
import Type1 from "./images/ortho_anomalies.png";
import Type2 from "./images/media_ortho.png";
import "./index.scss";
import { useTranslation } from "../../../i18n";

const OrthodonticSelect = ({
  selectStep
}) => {
  const {
    _t
  } = useTranslation();
  const types = [{
    key: "orthodonticAnomalies",
    img: Type1,
    name: _t("Изучить типы аномалий. Просмотреть примеры лечения.")
  }, {
    key: "orthodonticTreatment",
    img: Type2,
    name: _t("Выбрать вид ортодонтического лечения")
  }];

  function setStep(key) {
    selectStep(key);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "orthodonticSelect"
  }, /*#__PURE__*/React.createElement("div", {
    className: "orthodonticSelect-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    outerTitle: el.name
  }))));
};

export default OrthodonticSelect;